import {
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Skeleton,
  Space,
  message,
} from "antd";
import "./styles/validatePartnerPopup.css";
import FormItem from "antd/es/form/FormItem";
import { CopyOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useState } from "react";
import config from "../../../config";

const base_url = config.base_url;
function ValidatePartnerRequestPopup({
  open,
  onCancel,
  onOk,
  userId,
  popup,
  data,
  setData,
  setFilteredData,
}) {
  const isPending = data?.status === "pending";
  const [messageApi, contextHolder] = message.useMessage();

  const [openMissingInfoModal, setOpenMissingInfoModal] = useState(false);
  const [loadingSkeleteon, setLoadingSkeleteon] = useState(true);
  const [paypal1Checked, setPaypal1Checked] = useState(false);
  const [paypal2Checked, setPaypal2Checked] = useState(false);
  const [bank1Checked, setBank1Checked] = useState(false);
  const [bank2Checked, setBank2Checked] = useState(false);
  const [bank3Checked, setBank3Checked] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [files, setFiles] = useState([]);
  const [form] = Form.useForm();
  const [user, setUser] = useState({});
  const success = (text) => {
    messageApi.open({
      type: "success",
      content: text,
    });
  };
  const missingInfo = async () => {
    await fetch(base_url + "admin/partners/validations/partner/reject", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body:
        paymentMethod === "paypal"
          ? `partner_id=${user.user_id}&paypal_verified=${paypal1Checked}&certiticate_name_verified=${paypal2Checked}`
          : `partner_id=${user.user_id}&bank_details_verified=${bank1Checked}&certiticate_name_verified=${bank2Checked}&certificate_statement_verified=${bank3Checked}`,
    })
      .then((res) => {
        console.log(res);
        updateTableData();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const validatePartner = async () => {
    if (data.payment_method === "paypal") {
      if (paypal1Checked && paypal2Checked) {
        await fetch(base_url + "admin/partners/validations/partner/validate", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, /",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `partner_id=${user.user_id}`,
        })
          .then((res) => {
            success("Partner Validated");
            updateTableData();
            onOk();
            setPaypal1Checked(false);
            setPaypal2Checked(false);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else if (data.payment_method === "bank") {
      if (bank1Checked && bank2Checked && bank3Checked) {
        await fetch(base_url + "admin/partners/validations/partner/validate", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, /",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `partner_id=${user.user_id}`,
        })
          .then((res) => {
            console.log(res);
            success("Partner Validated");
            updateTableData();
            onOk();
            setBank1Checked(false);
            setBank2Checked(false);
            setBank3Checked(false);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else return;
  };
  const closeMissingInfoModal = () => {
    setOpenMissingInfoModal(false);
    // missingInfo();
  };
  const updateTableData = () => {
    fetch(base_url + "admin/partners/validations/data", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: ``,
    })
      .then((res) => res.json())
      .then((res) => {
        const content = res.data
          .sort((a, b) => {
            return b.date - a.date;
          })
          .map((data, i) => {
            return {
              ...data,
              date: dayjs(res.data[0].date).format("YYYY-MM-DD"),
              completed_date: dayjs(res.data[0].completed_date).format(
                "YYYY-MM-DD"
              ),
              index: res.data.length - i,
            };
          });
        setData(content);
        setFilteredData(content);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchData = (userId) => {
    setLoadingSkeleteon(true);
    fetch(base_url + "admin/partners/view/partner", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `partner_id=${userId}`,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        setUser(res);
        setPaymentMethod(res.billing_method);

        setFiles(res.files);
        if (res.billing_method === "paypal") {
          form.setFieldsValue({
            paypal_account: res.paypal_account,
            partnerName: data.contact_name,
            partnerType: res.type,
            emailAddress: res.email_address,
            phoneNumber: res.phone_number,
            missedInfo: res.email_address,
            contact_full_name: data.contact_name,
          });
        } else {
          form.setFieldsValue({
            account_owner_name: res.bank_owner_name,
            country: res.bank_country,
            bic: res.bank_bic,
            iban: res.bank_iban,
            partnerName: data.contact_name,
            contact_full_name: data.contact_name,
            partnerType: res.type,

            emailAddress: res.email_address,
            phoneNumber: res.phone_number,
            transaction_date: dayjs(new Date().now),
            missedInfo: res.email_address,
          });
        }
        setLoadingSkeleteon(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingSkeleteon(false);
      });
  };
  const downloadFile = async (fileId, fileName) => {
    await fetch(base_url + "admin/partners/download/partner/document", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `partner_id=${userId}&file_id=${fileId}`,
    })
      .then((res) => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Modal
      className="validateModal"
      open={open}
      onCancel={(e) => {
        onCancel();
        form.resetFields();
        setBank1Checked(false);
        setBank2Checked(false);
        setBank3Checked(false);
        setPaypal1Checked(false);
        setPaypal2Checked(false);
      }}
      onOk={onOk}
      afterOpenChange={(e) => {
        if (e === true) {
          fetchData(userId);
          return;
        }
        if (e === false) {
          setLoadingSkeleteon(true);
          return;
        }
      }}
      footer={[
        <div
          key={2}
          style={{
            display: "flex",
            padding: "0 25px",
            marginTop: "40px",
            justifyContent: "space-between",
          }}
        >
          <Button
            disabled={isPending ? false : true}
            className="missingInfo"
            onClick={(e) => {
              setOpenMissingInfoModal(true);
              missingInfo();
            }}
          >
            Missing or Incorrect Information
          </Button>

          <Button
            style={{
              height: "40px",
              marginLeft: "auto",
            }}
            onClick={(e) => {
              onCancel();
            }}
          >
            Cancel
          </Button>
          {paymentMethod === "paypal" ? (
            <Button
              onClick={(e) => {
                validatePartner();
              }}
              className="markCompleteButton"
              disabled={
                isPending
                  ? paypal1Checked && paypal2Checked
                    ? false
                    : true
                  : true
              }
            >
              Validate Partner
            </Button>
          ) : (
            <Button
              onClick={(e) => {
                validatePartner();
              }}
              className="markCompleteButton"
              disabled={
                isPending
                  ? bank1Checked && bank2Checked && bank3Checked
                    ? false
                    : true
                  : true
              }
            >
              Validate Partner
            </Button>
          )}
        </div>,
      ]}
    >
      <h2>Validate Partner Request</h2>
      {contextHolder}
      <Skeleton
        loading={loadingSkeleteon}
        paragraph={{
          rows: 18,
        }}
      >
        <Form form={form} className="container">
          <div className="containerFirstSection">
            <div className="containerLeftColumn">
              <p className="containerLeftColumnSubtitle">Attached Files</p>
              <div
                style={{
                  color: "#0091EA",
                }}
                className="containerLeftColumnFirstRow"
              >
                {files.map((file, i) => {
                  if (file.fileType === "certificateOfInco") {
                    return (
                      <span
                        onClick={(e) => {
                          downloadFile(file.id, file.fileName);
                        }}
                        style={{ cursor: "pointer", width: "max-content" }}
                        key={i}
                      >
                        Certificate of Incorporation
                      </span>
                    );
                  } else if (file.fileType === "bank_statement") {
                    return (
                      <span
                        onClick={(e) => {
                          downloadFile(file.id, file.fileName);
                        }}
                        style={{ cursor: "pointer", width: "max-content" }}
                        key={i}
                      >
                        Bank Accounts Statment
                      </span>
                    );
                  }
                  return <span key={i}>1</span>;
                })}
                {/* <p>Bank Account Statment</p>
                <p>Certificate of Incorporation</p> */}
              </div>
              <p className="containerLeftColumnSubtitle">
                Method:&nbsp;
                {paymentMethod &&
                  paymentMethod[0].toUpperCase() + paymentMethod.substring(1)}
              </p>
              {paymentMethod === "paypal" && (
                <div className="formItemWrapper">
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Paypal Account"
                    name="paypal_account"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["paypal_account"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>
              )}
              {paymentMethod !== "paypal" && (
                <>
                  <div className="formItemWrapper">
                    <FormItem
                      style={{
                        width: "100%",
                      }}
                      label="Account Owner Name"
                      name="account_owner_name"
                      labelCol={{ span: 24 }}
                    >
                      <Input disabled className="formInput" />
                    </FormItem>
                    <CopyOutlined
                      onClick={(e) => {
                        navigator.clipboard.writeText(
                          form.getFieldValue(["account_owner_name"])
                        );
                        success("Text Copied");
                      }}
                      className="InputCopyicon"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "25px",
                    }}
                  >
                    <div className="formItemWrapper">
                      <FormItem
                        style={{
                          width: "100%",
                        }}
                        label="Country"
                        name="country"
                        labelCol={{ span: 24 }}
                      >
                        <Input disabled className="formInput" />
                      </FormItem>
                      <CopyOutlined
                        onClick={(e) => {
                          navigator.clipboard.writeText(
                            form.getFieldValue(["country"])
                          );
                          success("Text Copied");
                        }}
                        className="InputCopyicon"
                      />
                    </div>
                    <div className="formItemWrapper">
                      <FormItem
                        style={{
                          width: "100%",
                        }}
                        label="BIC"
                        name="bic"
                        labelCol={{ span: 24 }}
                      >
                        <Input disabled className="formInput" />
                      </FormItem>
                      <CopyOutlined
                        onClick={(e) => {
                          navigator.clipboard.writeText(
                            form.getFieldValue(["bic"])
                          );
                          success("Text Copied");
                        }}
                        className="InputCopyicon"
                      />
                    </div>
                  </div>
                  <div
                    className="formItemWrapper"
                    style={{
                      width: "100%",
                    }}
                  >
                    <FormItem
                      style={{
                        width: "100%",
                      }}
                      label="IBAN"
                      name="iban"
                      labelCol={{ span: 24 }}
                    >
                      <Input disabled className="formInput" />
                    </FormItem>
                    <CopyOutlined
                      onClick={(e) => {
                        navigator.clipboard.writeText(
                          form.getFieldValue(["iban"])
                        );
                        success("Text Copied");
                      }}
                      className="InputCopyicon"
                    />
                  </div>
                </>
              )}
            </div>
            <div className="containerRightColumn">
              <p className="containerRightColumnSubtitle">
                Partner's Contact Details
              </p>
              <div className="containerRightColumnWrapper">
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Partner Name / Company / Brand Name"
                    name="partnerName"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["partnerName"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Partner Type"
                    name="partnerType"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["partnerType"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Contact full Name"
                    name="contact_full_name"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["contact_full_name"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>{" "}
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Partner Email Address"
                    name="emailAddress"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["emailAddress"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>{" "}
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Contact phone Number"
                    name="phoneNumber"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["phoneNumber"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>
              </div>
            </div>
          </div>
          {paymentMethod === "paypal" && (
            <div
              style={{
                position: "absolute",
                bottom: "100px",
              }}
            >
              <p className="containerLeftColumnSubtitle">Admin Approval</p>
              <div className="containerSecondSection">
                <FormItem name="invoice_confirmation">
                  <Space direction="vertical">
                    <Checkbox
                      onChange={(e) => {
                        setPaypal1Checked(e.target.checked);
                      }}
                      style={{
                        fontSize: "12px ",
                      }}
                    >
                      Confirm the PayPal account include indication of the
                      partner business/identity
                    </Checkbox>
                    <Checkbox
                      onChange={(e) => {
                        setPaypal2Checked(e.target.checked);
                      }}
                      style={{
                        fontSize: "12px ",
                      }}
                    >
                      Confirm certificate of incorporation is valid and matching
                      the partner company/brand name
                    </Checkbox>
                  </Space>
                </FormItem>
              </div>
            </div>
          )}
          {paymentMethod !== "paypal" && (
            <>
              <p className="containerLeftColumnSubtitle">Admin Approval</p>
              <div className="containerSecondSection">
                <FormItem name="invoice_confirmation">
                  <Space direction="vertical">
                    <Checkbox
                      onChange={(e) => {
                        setBank1Checked(e.target.checked);
                      }}
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Confirm the bank details are matching the bank account
                      Statement
                    </Checkbox>
                    <Checkbox
                      onChange={(e) => {
                        setBank2Checked(e.target.checked);
                      }}
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Confirm certificate of incorporation is valid and matching
                      the partner company/brand name
                    </Checkbox>
                    <Checkbox
                      onChange={(e) => {
                        setBank3Checked(e.target.checked);
                      }}
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Confirm the name of certificate of incorporation is
                      matching the name of the bank account statment
                    </Checkbox>
                  </Space>
                </FormItem>
              </div>
            </>
          )}

          <Modal
            closeIcon={false}
            open={openMissingInfoModal}
            onCancel={closeMissingInfoModal}
            className="missingInfoModal"
            footer={[
              <div
                style={{
                  display: "flex",
                }}
              >
                <Button
                  onClick={(e) => {
                    closeMissingInfoModal();
                    setTimeout(() => {
                      onCancel();
                    }, 100);
                  }}
                  style={{
                    margin: "auto",
                    width: "165px",
                  }}
                  className="missingInfo"
                >
                  Close Request Window
                </Button>
              </div>,
            ]}
          >
            <div className="missingInfoModalContent">
              <h2>Status Changed!</h2>
              <p>Contact the partner by email to report him for the issue</p>
              <div
                className="formItemWrapper"
                style={{
                  height: "max-content",
                }}
              >
                <FormItem
                  style={{
                    width: "100%",
                  }}
                  name="missedInfo"
                >
                  <Input disabled className="formInput" />
                </FormItem>
                <CopyOutlined
                  style={{
                    bottom: "38px",
                  }}
                  onClick={(e) => {
                    navigator.clipboard.writeText(
                      form.getFieldValue(["missedInfo"])
                    );
                    success("Text Copied");
                  }}
                  className="InputCopyicon"
                />
              </div>
            </div>
          </Modal>
        </Form>
      </Skeleton>
    </Modal>
  );
}

export default ValidatePartnerRequestPopup;
